import React from "react";
import cl from "./AboutInfo.module.css";
import Aboutus from "../../../image/aboutus.jpg";

const AboutInfo = (props) => {
  return (
    <section className={cl.about}>
      <h1>Our story</h1>
      <img className={cl.big_image} src={Aboutus} />
      <p>{props.shopStory}</p>
    </section>
  );
};

export default AboutInfo;
